import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

class LinkComponent extends React.Component {
    render() {
        const { title, url, className, isExternalLink, location: { pathname } } = this.props

        return isExternalLink
            ? <a
                className={className}
                target="_blank"
                rel="noopener noreferrer"
                href={url}
            >
                {title}
            </a>
            : <Link
                className={className}
                to={{
                    pathname: url,
                    state: { prevPath: pathname },
                }}
            >{title}</Link>
    }
}

LinkComponent.defaultProps = {
    className: '',
    isExternalLink: false,
}

LinkComponent.propTypes = {
    title: PropTypes.node.isRequired,
    url: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    isExternalLink: PropTypes.bool,
    location: PropTypes.object.isRequired,
}

export default withRouter(LinkComponent)



// WEBPACK FOOTER //
// ./src/components/core/LinkComponent/LinkComponent.js